<template>
  <div class="h-full relative">
    <p class="py-1 text-bnb-brown">Remember to update your quantity</p>
    <EmptyCart
      v-if="$store.state.menu.length == 0 || cartItemsIDs.length == 0"
    />
    <div v-else class="h-full relative flex flex-col px-2 pb-36">
      <!-- CART ITEMS DIV -->
      <div class="flex-1 overflow-scroll">
        <CartItem
          @removeItem="removeCartItem"
          @updateItem="updateCartItem"
          v-for="(item, index) in cartItemsIDs"
          :key="item"
          :itemID="item"
          :index="index"
        />
      </div>
      <!-- CHECKOUT AND SUBTOTAL -->
      <div
        class="
          fixed
          gutterpaddingbottom
          bg-white
          gray-200
          shadow-inner
          flex
          justify-between
          max-w-5xl
          mx-auto
          bottom-14
          left-0
          w-full
          p-2
          font-bold
          items-center
        "
      >
        <p>
          SUBTOTAL:
          <span class="flex-1 text-bnb-mustard text-xl"> ₦{{ subtotal }}</span>
        </p>
        <button
          @click="checkout"
          :class="[cartReady ? 'bg-bnb-mustard' : 'bg-gray-500']"
          class="
            flex
            z-50
            items-center
            focus:outline-none
            shadow-lg
            mx-2
            border-2 border-white
            text-white
            font-bold
            p-2
            text-lg
            rounded-full
          "
        >
          <img alt="logo" class="h-6 mr-1" src="@/assets/logoshort.png" />
          CHECKOUT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CartItem from "@/views/cart/CartItem.vue";
import EmptyCart from "@/views/cart/EmptyCart.vue";
export default {
  components: { EmptyCart, CartItem },
  created() {
    try {
      this.cartItemsIDs = JSON.parse(localStorage.cart);
    } catch (error) {
      localStorage.removeItem("cart");
      console.error(error);
    }
  },
  data() {
    return {
      cartItemsIDs: [],
      cartItems: {},
    };
  },
  computed: {
    cartReady() {
      return Object.keys(this.cartItems).length == this.cartItemsIDs.length;
    },
    subtotal() {
      try {
        var sum = 0;
        this.cartItemsIDs.forEach((id) => {
          sum +=
            this.$store.getters.menuItem(id)?.price *
            this.cartItems[id].quantity;
        });
        return sum;
      } catch (error) {
        return 10000000000000000000000000000000000000000000000000000000000;
      }
    },
  },
  methods: {
    checkout() {
      if (this.cartReady) {
        localStorage.checkout = JSON.stringify(this.cartItems);
        this.$router.push({ name: "Checkout" });
      } else {
        this.$toast.error("Cart Loading!", {
          position: "bottom",
          duration: 2000,
        });
      }
    },
    updateCartItem(id, quantity) {
      this.cartItems[id] = {
        id: id,
        quantity: quantity,
      };
    },
    removeCartItem(id) {
      delete this.cartItems[id];
      this.cartItemsIDs = this.cartItemsIDs.filter((e) => e != id);
      localStorage.cart = JSON.stringify(this.cartItemsIDs);
      this.$toast.show("Cart Item removed!", {
        position: "bottom",
        duration: 500,
      });
    },
  },
};
</script>
